import React from "react";

export const Note = ({ topic, text }) => {
  return (
    <div className="note my-3 fw-400">
      <span className="fw-600 note-icon p-2 text-capitalize">{topic}</span>
      <span className="note-text p-2"> {text}</span>
    </div>
  );
};
